import { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const faqs = [
  { id: 1, question: 'چگونه می‌توانم سفارش خود را ثبت کنم؟', answer: 'برای ثبت سفارش، محصول مورد نظر را به سبد خرید اضافه کنید و سپس مراحل ثبت سفارش را تا تکمیل اطلاعات و پرداخت ادامه دهید.' },
  { id: 2, question: 'مدت زمان ارسال سفارش چقدر است؟', answer: 'زمان ارسال بسته به محل سکونت شما بین ۲ تا ۵ روز کاری متغیر است و پس از ارسال، کد رهگیری برای شما ارسال می‌شود.' },
  { id: 3, question: 'آیا امکان مرجوعی کالا وجود دارد؟', answer: 'بله، در صورت عدم رضایت از محصول، تا ۷ روز کاری امکان بازگشت کالا وجود دارد.' },
  { id: 4, question: 'چگونه از تخفیف‌ها مطلع شوم؟', answer: 'با عضویت در خبرنامه و دنبال کردن ما در شبکه‌های اجتماعی، از آخرین تخفیف‌ها با خبر شوید.' },
  { id: 5, question: 'آیا محصولات گارانتی دارند؟', answer: 'بله، تمام محصولات دارای گارانتی اصالت و کیفیت به همراه ضمانت ۱۲ ماهه هستند.' },
  { id: 6, question: 'چگونه با پشتیبانی تماس بگیرم؟', answer: 'از طریق شماره تلفن ۰۲۱-۱۲۳۴۵۶۷۸ یا ایمیل info@erisswood.com با ما در ارتباط باشید.' },
];

const HowToBuyTab = () => {
  const [openId, setOpenId] = useState(null);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-[#292524]">راهنمای خرید</h2>
          <p className="text-sm text-[#79716B] mt-1">پاسخ به سوالات متداول شما</p>
        </div>
        <span className="text-xs font-medium text-[#9EAD8C] bg-[#9EAD8C]/10 px-3 py-1 rounded-full">
          {faqs.length} سوال متداول
        </span>
      </div>

      <div className="space-y-3">
        {faqs.map((faq) => {
          const isOpen = openId === faq.id;
          return (
            <div
              key={faq.id}
              className={`rounded-xl border transition-all duration-300 overflow-hidden ${
                isOpen
                  ? 'border-[#9EAD8C] shadow-md shadow-[#9EAD8C]/10'
                  : 'border-[#D9D9D9]/50 hover:border-[#D9D9D9]'
              }`}
            >
              <button
                className="w-full flex justify-between items-center px-5 py-4 text-right transition-all hover:bg-[#F4F1EA]/50"
                onClick={() => setOpenId(isOpen ? null : faq.id)}
              >
                <span className="text-sm font-medium text-[#292524] flex-1">{faq.question}</span>
                <span
                  className={`text-[#9EAD8C] text-sm font-light flex-shrink-0 transition-all duration-300 ml-3 ${
                    isOpen ? 'rotate-180' : ''
                  }`}
                >
                  <FaChevronDown className="w-4 h-4" />
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-4 pt-1 border-t border-[#D9D9D9]/30">
                  <p className="text-sm text-[#79716B] leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-6 p-5 bg-gradient-to-r from-[#F4F1EA] to-[#FDFCFA] rounded-xl border border-[#D9D9D9]/50 text-center">
        <p className="text-sm text-[#79716B]">
          سوال دیگری دارید؟{' '}
          <a href="/contact" className="text-[#9EAD8C] font-medium hover:underline">
            با پشتیبانی تماس بگیرید
          </a>
        </p>
      </div>
    </div>
  );
};

export default HowToBuyTab;